import { MockApiClient } from './mock';
import { RealApiClient } from './real';
import { HybridApiClient } from './hybrid';
import type { ITinderApiClient } from './client';

/**
 * API Provider
 */
class ApiProvider {
  private client: ITinderApiClient;

  constructor() {
    // Use Real API for everything
    this.client = new RealApiClient();
  }

  getClient(): ITinderApiClient {
    return this.client;
  }

  setClient(client: ITinderApiClient): void {
    this.client = client;
  }
}

// Singleton instance
export const apiProvider = new ApiProvider();

// Default export for convenience
export const api = apiProvider.getClient();

// Export types and classes
export type { ITinderApiClient } from './client';
export { BaseApiClient } from './client';
export { MockApiClient } from './mock';
export { RealApiClient } from './real';
export { HybridApiClient } from './hybrid';
